import { AxiosResponse } from 'axios';

import { dismissAllNotifications, loadNotifications, updateNotifications } from '@/api/notification';
import { NotificationItem } from '@/models/notification';
import { baseListService } from '@/services/baseService';
import { IApiModifyResponse, INotificationApiListResponse } from '@/types';
import { IListParams } from '@/types/service';
import { AppError } from '@/errors/appError';
import { useNotificationStore } from '@/stores/notification';
import { useAppStore } from '@/stores/app';

export const notificationService = {
    async load(params: IListParams): Promise<AxiosResponse<INotificationApiListResponse>> {
        const notificationStore = useNotificationStore();
        const appStore = useAppStore();

        appStore.loading = true;
        try {
            const response = await baseListService<INotificationApiListResponse>(loadNotifications, params);
            notificationStore.items = response.data.rows.map((item) => new NotificationItem(item));
            notificationStore.total = response.data.total;

            return response;
        } catch (e) {
            throw new AppError(`Unable load notification list, request error`, { cause: e });
        } finally {
            appStore.loading = false;
        }
    },

    async update(notificationId: number): Promise<AxiosResponse<IApiModifyResponse>> {
        try {
            return await updateNotifications({ rows: [{ id: notificationId, is_viewed: true }] });
        } catch (e) {
            throw new AppError(`Unable to update notification #${notificationId}, request error`, { cause: e });
        } finally {
        }
    },

    async dismissAll(): Promise<AxiosResponse<IApiModifyResponse>> {
        try {
            return await dismissAllNotifications();
        } catch (e) {
            throw new AppError(`Unable to dismiss all notifications, request error`, { cause: e });
        } finally {
        }
    },
};
